import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Basit uygulama metinleri için kaynaklar
const resources = {
    tr: {
        translation: {
            nav: {
                photos: "FOTOĞRAFLAR",
                about: "HAKKIMIZDA",
                contact: "İLETİŞİM",
                social: "SOSYAL MEDYA",
                openMenu: "Menüyü aç",
                closeMenu: "Menüyü kapat",
            },
            actions: {
                seeAll: "Tümünü Gör",
            },
            breadcrumb: {
                home: "Ana Sayfa",
                work: "Fotoğraflar",
                about: "Hakkımızda",
                contact: "İletişim",
                social: "Sosyal Medya",
                webServices: "Web Hizmetleri",
            },
            work: {
                heading: "Fotoğraf Çalışmalarımız — Kochan Productions",
            },
            hero: {
                name: "MÜCAHİT KOÇHAN",
                subtitle: "VİDEOGRAFİKER & SOSYAL MEDYA UZMANI",
            },
            blockquote: {
                welcome: "Kochan Productions’a hoş geldiniz! İşletmenizin hikayesini etkileyici videolar ve fotoğraflarla anlatıyoruz. Profesyonel ekipmanlarımızla, sosyal medya için özel içerikler üreterek markanızı bir üst seviyeye taşıyoruz. Güveninize layık, size özel çözümlerle tanışmaya hazır mısınız? Birlikte harika işler yapalım!",
            },
            footer: {
                createdBy: "Oluşturan",
                rights: "Tüm Hakları Saklıdır",
                siteName: "MUCAHITKOCHAN",
            },
            about: {
                titleName: "MÜCAHİT KOÇHAN",
                role: "VİDEOGRAFİKER",
                p1: "Kochan Productions, yılların deneyimiyle video, fotoğrafçılık ve sosyal medya alanında hizmet vermektedir. Bu sektöre olan tutkumuz, hobi olarak başladığımız bir yolculuğun ardından profesyonel bir işe dönüşmüştür. Yaratıcılığı ve estetiği ön planda tutarak, markaların hikayelerini etkileyici bir şekilde anlatmayı hedefliyoruz.",
                p2: "Devlet kurumları ve özel işletmelerle gerçekleştirdiğimiz projelerle, geniş bir müşteri portföyüne sahibiz. Sosyal medya yönetimi konusunda sunduğumuz hizmetlerle, markalarınıza özel içerikler üreterek dijital dünyada görünürlüğünüzü artırıyoruz. Her projede, yüksek kaliteli içerikler üreterek markanızı bir üst seviyeye taşımayı amaçlıyoruz.",
                p3: "Güveninize layık, size özel çözümler sunarak, hayallerinizi gerçeğe dönüştürmek için buradayız. Kochan Productions ile birlikte, unutulmaz projelere imza atmaya hazır mısınız?",
                quote: "İyi bir fotoğraf nerede duracağını bilir",
                quoteAuthor: "- Ansel Adams",
            },
            contact: {
                title: "BİZE ULAŞIN",
                subtitle: "Projeniz için ideal çekim planını birlikte oluşturalım. İhtiyaçlarınızı bize kısaca anlatın, sizin için en uygun çözümleri sunalım.",
                phone: "+90 539 354 10 77",
                phoneLabel: "Bizi Arayın",
                email: "mansurpeker7@gmail.com",
                emailLabel: "Bize Ulaşın",
                address: "Rüstempaşa Mah. Hürriyet Sk. No: 3/12 Kat: 2 Yalova",
                addressLabel: "Ofisimizi Ziyaret Edin",
                form: {
                    name: "Ad",
                    surname: "Soyad",
                    emailField: "E-Posta",
                    phone: "Telefon Numarası",
                    message: "Mesaj",
                    submit: "Gönder",
                    sending: "Gönderiliyor...",
                    success: "Mesajınız başarıyla gönderildi!",
                    error: "Bir hata oluştu. Lütfen tekrar deneyin.",
                },
            },

            social: {
                heading: "Sosyal Medya Yönetimi ve İçerik Üretimi",
                p1: "Sosyal medya, markanızın dijital dünyada sesini duyurmanın en güçlü yollarından biridir. Kochan Productions olarak, yılların tecrübesiyle hem özel işletmelerin hem de resmi kurumların sosyal medya hesaplarını başarıyla yönettik. Profesyonel içerik üretiminden strateji geliştirmeye kadar her adımda markanızı öne çıkarmayı hedefliyoruz. Güvenilir ve etkili sosyal medya yönetimiyle, takipçilerinizin ilgisini çekip, markanızın dijital varlığını güçlendirmek için yanınızdayız. Bize güvenin, sosyal medyanızda fark yaratın!",
                p2: "Dijital dünyada markanızın güçlü bir ses bulmasını sağlamak için sosyal medya, en etkili araçlardan biridir. Kochan Productions olarak yıllara dayanan deneyimimizle özel işletmelerin yanı sıra resmi kurumların sosyal medya hesaplarını başarıyla yönetiyoruz. Profesyonel içerik oluşturma, özgün strateji geliştirme ve analiz süreçleriyle markanızı ön plana çıkarıyoruz. Güvenilir ve etkili sosyal medya yönetimiyle takipçilerinizin dikkatini çeker, dijital varlığınızı sağlamlaştırırız. Markanızın sosyal medyada fark yaratmasını istiyorsanız, doğru adrestesiniz!",
                servicesHeading: "Sunduğumuz Sosyal Medya Hizmetleri",
                services: {
                    content: {
                        title: "İçerik Üretimi",
                        desc: "Markanızın kimliğine uygun, özgün ve dikkat çekici fotoğraf ile video içerikleri üretiyoruz.",
                    },
                    management: {
                        title: "Hesap Yönetimi",
                        desc: "Paylaşım takvimi, mesaj yanıtlama ve topluluk yönetimiyle hesaplarınızı düzenli ve aktif tutuyoruz.",
                    },
                    reels: {
                        title: "Reels & Kısa Video",
                        desc: "Kısa video formatlarıyla markanızın hikayesini akıcı ve etkileşimi yüksek şekilde anlatıyoruz.",
                    },
                    analytics: {
                        title: "Planlama & Analiz",
                        desc: "Performans verilerini analiz ederek stratejinizi sürekli iyileştiriyor, sonuç odaklı ilerliyoruz.",
                    },
                },
            },
            services: {
                title: "HİZMETLERİMİZ",
                subtitle: "Profesyonel ekibimizle markanıza özel çözümler sunuyoruz.",
                items: {
                    video: {
                        title: "Video Prodüksiyon",
                        desc: "Kurumsal tanıtım, reklam ve sosyal medya için profesyonel video çekimi ve prodüksiyon hizmetleri.",
                    },
                    photo: {
                        title: "Fotoğrafçılık",
                        desc: "Ürün, etkinlik, portre ve mimari fotoğrafçılık alanlarında yüksek kaliteli görsel üretimi.",
                    },
                    social: {
                        title: "Sosyal Medya Yönetimi",
                        desc: "Markanızın dijital kimliğini güçlendiren içerik stratejisi, üretim ve hesap yönetimi hizmetleri.",
                    },
                    drone: {
                        title: "Drone Çekimi",
                        desc: "Hava fotoğrafçılığı ve video ile etkileyici üst açı görüntüler. İnşaat, turizm ve etkinlik projeleri için.",
                    },
                    edit: {
                        title: "Video Kurgu & Post",
                        desc: "Renk düzeltme, ses tasarımı ve özel efektlerle videolarınıza profesyonel bir son dokunuş.",
                    },
                    live: {
                        title: "Web Hizmetleri",
                        desc: "Kurumsal web sitesi tasarımı, geliştirme ve bakım hizmetleri. Modern ve responsive web çözümleri.",
                    },
                },
            },
            webServices: {
                title: "WEB HİZMETLERİMİZ",
                subtitle: "Geliştirdiğimiz ve yönettiğimiz web siteleri",
                visitSite: "Siteyi Ziyaret Et",
            },
            seo: {
                home: {
                    title: "Kochan Productions | Video Prodüksiyon & Sosyal Medya | Yalova",
                    description: "Yalova merkezli profesyonel video prodüksiyon, fotoğraf ve sosyal medya yönetimi. Kurumsal tanıtım filmi, reklam videosu ve drone çekimiyle markanızı öne çıkarın.",
                },
                work: {
                    title: "Fotoğraflarımız | Kochan Productions",
                    description: "Ürün, etkinlik, portre ve mimari fotoğrafçılık alanlarında profesyonel çalışmalarımızı görüntüleyin. Kochan Productions fotoğraf portföyü.",
                },
                about: {
                    title: "Hakkımızda | Kochan Productions - Mücahit Koçhan",
                    description: "Kochan Productions, yılların deneyimiyle video, fotoğrafçılık ve sosyal medya alanında hizmet vermektedir. Kurucumuz Mücahit Koçhan hakkında bilgi edinin.",
                },
                contact: {
                    title: "İletişim | Kochan Productions - Yalova",
                    description: "Kochan Productions ile iletişime geçin. Profesyonel video prodüksiyon, fotoğraf çekimi ve sosyal medya hizmetleri için bize ulaşın. Yalova, Türkiye.",
                },
                socialMedia: {
                    title: "Sosyal Medya Yönetimi | Kochan Productions",
                    description: "Profesyonel sosyal medya yönetimi hizmetleri. İçerik stratejisi, hesap yönetimi ve dijital pazarlama ile markanızın online varlığını güçlendirin.",
                },
                webServices: {
                    title: "Web Hizmetleri | Kochan Productions",
                    description: "Yalova'daki işletmeler için kurumsal web sitesi tasarımı, geliştirme ve bakım hizmetleri sunuyoruz. Modern, hızlı, responsive ve SEO uyumlu web çözümleri.",
                },
                projects: {
                    titleSuffix: " | Kochan Productions",
                    descriptionPrefix: "Kochan Productions - ",
                    descriptionSuffix: " kategorisindeki profesyonel video prodüksiyon çalışmalarımız.",
                },
            },
            notFound: {
                title: "Sayfa Bulunamadı | Kochan Productions",
                heading: "Sayfa Bulunamadı",
                description: "Aradığınız sayfa taşınmış veya hiç var olmamış olabilir. Ana sayfadan çalışmalarımıza göz atabilirsiniz.",
                backHome: "Ana Sayfaya Dön",
            },
        },
    },
    en: {
        translation: {
            nav: {
                photos: "PHOTOS",
                about: "ABOUT",
                contact: "CONTACT",
                social: "SOCIAL MEDIA",
                openMenu: "Open menu",
                closeMenu: "Close menu",
            },
            actions: {
                seeAll: "See All",
            },
            breadcrumb: {
                home: "Home",
                work: "Photos",
                about: "About",
                contact: "Contact",
                social: "Social Media",
                webServices: "Web Services",
            },
            work: {
                heading: "Our Photography Work — Kochan Productions",
            },
            hero: {
                name: "MUCAHIT KOCHAN",
                subtitle: "VIDEOGRAPHER & SOCIAL MEDIA SPECIALIST",
            },
            blockquote: {
                welcome: "Welcome to Kochan Productions! We tell your brand’s story with impressive videos and photos. With professional equipment, we produce content tailored for social media to elevate your brand. Ready to meet reliable, tailored solutions you can trust? Let’s create great things together!",
            },
            footer: {
                createdBy: "Created by",
                rights: "All Rights Reserved",
                siteName: "MUCAHITKOCHAN",
            },
            about: {
                titleName: "MUCAHIT KOCHAN",
                role: "VIDEOGRAPHER",
                p1: "Kochan Productions provides services in video, photography, and social media with years of experience. Our passion for this field turned a hobby into a professional journey. We aim to tell brand stories impressively, prioritizing creativity and aesthetics.",
                p2: "We have a broad client portfolio through projects with public institutions and private businesses. With our social media management services, we produce tailored content to increase your digital presence. In every project, we aim to elevate your brand with high-quality content.",
                p3: "We are here to turn your dreams into reality by offering reliable, tailored solutions. Ready to create unforgettable projects together with Kochan Productions?",
                quote: "A good photograph knows where to stand",
                quoteAuthor: "- Ansel Adams",
            },
            contact: {
                title: "CONTACT US",
                subtitle: "Let's create the ideal shooting plan for your project together. Briefly describe your needs, and we'll offer you the best solutions.",
                phone: "+90 539 354 10 77",
                phoneLabel: "Call Us",
                email: "mansurpeker7@gmail.com",
                emailLabel: "Contact Us",
                address: "Rüstempaşa Mah. Hürriyet Sk. No: 3/12 Kat: 2 Yalova",
                addressLabel: "Visit Our Office",
                form: {
                    name: "Name",
                    surname: "Surname",
                    emailField: "Email",
                    phone: "Phone Number",
                    message: "Message",
                    submit: "Send",
                    sending: "Sending...",
                    success: "Your message has been sent successfully!",
                    error: "An error occurred. Please try again.",
                },
            },

            social: {
                heading: "Social Media Management and Content Production",
                p1: "Social media is one of the most powerful ways to make your brand heard in the digital world. At Kochan Productions, with years of experience, we have successfully managed the social media accounts of both private businesses and public institutions. From professional content production to strategy, we aim to make your brand stand out. Trust us to strengthen your digital presence and create impact!",
                p2: "To help your brand find a strong voice in the digital world, social media is one of the most effective tools. With years of experience, we successfully manage the social media accounts of both private businesses and public institutions. With professional content, unique strategy, and analysis, we bring your brand to the forefront. We draw attention and solidify your digital presence.",
                servicesHeading: "Our Social Media Services",
                services: {
                    content: {
                        title: "Content Production",
                        desc: "We produce original, eye-catching photo and video content that fits your brand identity.",
                    },
                    management: {
                        title: "Account Management",
                        desc: "We keep your accounts active and organized with a posting calendar, replies, and community management.",
                    },
                    reels: {
                        title: "Reels & Short Video",
                        desc: "We tell your brand's story in an engaging, high-impact way through short video formats.",
                    },
                    analytics: {
                        title: "Planning & Analytics",
                        desc: "We analyze performance data to continuously refine your strategy and stay result-driven.",
                    },
                },
            },
            services: {
                title: "OUR SERVICES",
                subtitle: "We offer tailored solutions for your brand with our professional team.",
                items: {
                    video: {
                        title: "Video Production",
                        desc: "Professional video shooting and production for corporate presentations, advertisements, and social media.",
                    },
                    photo: {
                        title: "Photography",
                        desc: "High-quality visual production in product, event, portrait, and architectural photography.",
                    },
                    social: {
                        title: "Social Media Management",
                        desc: "Content strategy, production, and account management services that strengthen your brand's digital identity.",
                    },
                    drone: {
                        title: "Drone Shooting",
                        desc: "Impressive aerial photography and video with top-angle views. Ideal for construction, tourism, and events.",
                    },
                    edit: {
                        title: "Video Editing & Post",
                        desc: "Color grading, sound design, and special effects — a professional finishing touch for your videos.",
                    },
                    live: {
                        title: "Web Services",
                        desc: "Corporate website design, development, and maintenance services. Modern and responsive web solutions.",
                    },
                },
            },
            webServices: {
                title: "OUR WEB SERVICES",
                subtitle: "Websites we've developed and managed",
                visitSite: "Visit Website",
            },
            seo: {
                home: {
                    title: "Kochan Productions | Video Production & Social Media | Yalova, Turkey",
                    description: "Professional video production, photography and social media management in Yalova, Turkey. Corporate videos, ads and drone footage that elevate your brand.",
                },
                work: {
                    title: "Our Photography | Kochan Productions",
                    description: "View our professional work in product, event, portrait and architectural photography. Kochan Productions photo portfolio.",
                },
                about: {
                    title: "About Us | Kochan Productions - Mucahit Kochan",
                    description: "Kochan Productions provides video, photography and social media services with years of experience. Learn about our founder Mucahit Kochan.",
                },
                contact: {
                    title: "Contact | Kochan Productions - Yalova, Turkey",
                    description: "Get in touch with Kochan Productions for professional video production, photography and social media services. Yalova, Turkey.",
                },
                socialMedia: {
                    title: "Social Media Management | Kochan Productions",
                    description: "Professional social media management services. Strengthen your brand's online presence with content strategy, account management and digital marketing.",
                },
                webServices: {
                    title: "Web Services | Kochan Productions",
                    description: "We build corporate websites for businesses in Yalova, Turkey — design, development and ongoing maintenance. Modern, fast, responsive and SEO-friendly solutions.",
                },
                projects: {
                    titleSuffix: " | Kochan Productions",
                    descriptionPrefix: "Kochan Productions - ",
                    descriptionSuffix: " category professional video production works.",
                },
            },
            notFound: {
                title: "Page Not Found | Kochan Productions",
                heading: "Page Not Found",
                description: "The page you are looking for may have been moved or never existed. You can browse our work from the home page.",
                backHome: "Back to Home",
            },
        },
    },
    ar: {
        translation: {
            nav: {
                photos: "صور",
                about: "عنا",
                contact: "تواصل",
                social: "وسائل التواصل",
                openMenu: "فتح القائمة",
                closeMenu: "إغلاق القائمة",
            },
            actions: {
                seeAll: "عرض الكل",
            },
            breadcrumb: {
                home: "الصفحة الرئيسية",
                work: "صور",
                about: "عنا",
                contact: "تواصل",
                social: "وسائل التواصل",
                webServices: "خدمات الويب",
            },
            work: {
                heading: "أعمالنا في التصوير الفوتوغرافي — Kochan Productions",
            },
            hero: {
                name: "موجاهيت كوتشان",
                subtitle: "مصور فيديو ومتخصص في وسائل التواصل",
            },
            blockquote: {
                welcome: "مرحبًا بكم في Kochan Productions! نحكي قصة علامتكم التجارية من خلال مقاطع فيديو وصور مؤثرة. نستخدم معدات احترافية وننتج محتوى مخصصًا لوسائل التواصل الاجتماعي لرفع مستوى علامتكم. هل أنتم مستعدون لحلول موثوقة ومخصصة؟ لنصنع أشياء رائعة معًا!",
            },
            footer: {
                createdBy: "تم الإنشاء بواسطة",
                rights: "جميع الحقوق محفوظة",
                siteName: "MUCAHITKOCHAN",
            },
            about: {
                titleName: "موجاهيت كوتشان",
                role: "مصوّر فيديو",
                p1: "تقدم Kochan Productions خدمات في مجالات الفيديو والتصوير ووسائل التواصل الاجتماعي بخبرة سنوات. شغفنا بهذا المجال حوّل الهواية إلى عمل احترافي. نهدف إلى سرد قصص العلامات التجارية بشكل مؤثر مع التركيز على الإبداع والجماليات.",
                p2: "لدينا قاعدة واسعة من العملاء من خلال مشاريع مع مؤسسات حكومية وشركات خاصة. من خلال خدمات إدارة وسائل التواصل، ننتج محتوى مخصصًا لزيادة الظهور الرقمي لعلامتكم. في كل مشروع، نهدف إلى الارتقاء بعلامتكم من خلال محتوى عالي الجودة.",
                p3: "نقدّم حلولاً موثوقة ومخصصة لتحقيق أحلامكم. هل أنتم مستعدون لإنجاز مشاريع لا تُنسى مع Kochan Productions؟",
                quote: "تعرف الصورة الجيدة أين تقف",
                quoteAuthor: "- أنسل آدامز",
            },
            contact: {
                title: "تواصل معنا",
                subtitle: "لنصنع معًا خطة التصوير المثالية لمشروعك. أخبرنا باحتياجاتك بإيجاز، وسنقدم لك أفضل الحلول.",
                phone: "+90 539 354 10 77",
                phoneLabel: "اتصل بنا",
                email: "mansurpeker7@gmail.com",
                emailLabel: "تواصل معنا",
                address: "Rüstempaşa Mah. Hürriyet Sk. No: 3/12 Kat: 2 Yalova",
                addressLabel: "زر مكتبنا",
                form: {
                    name: "الاسم",
                    surname: "اللقب",
                    emailField: "البريد الإلكتروني",
                    phone: "رقم الهاتف",
                    message: "الرسالة",
                    submit: "إرسال",
                    sending: "جاري الإرسال...",
                    success: "تم إرسال رسالتك بنجاح!",
                    error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
                },
            },

            social: {
                heading: "إدارة وسائل التواصل الاجتماعي وإنتاج المحتوى",
                p1: "تُعد وسائل التواصل الاجتماعي من أقوى الطرق لإسماع صوت علامتك في العالم الرقمي. في Kochan Productions وبخبرة سنوات، أدرنا حسابات وسائل التواصل لجهات خاصة ورسمية بنجاح. من إنتاج المحتوى الاحترافي إلى الاستراتيجية، نهدف إلى إبراز علامتك. وثِق بنا لتعزيز حضورك الرقمي وصنع تأثير!",
                p2: "للعثور على صوت قوي لعلامتك في العالم الرقمي، تُعد وسائل التواصل من أكثر الأدوات فعالية. بخبرتنا نُدير حسابات جهات خاصة ورسمية بنجاح. بالمحتوى الاحترافي والاستراتيجيات والتحليل نُبرز علامتك ونشدّ الانتباه ونقوّي حضورك الرقمي.",
                servicesHeading: "خدمات وسائل التواصل الاجتماعي لدينا",
                services: {
                    content: {
                        title: "إنتاج المحتوى",
                        desc: "ننتج محتوى مصورًا ومرئيًا أصيلًا وجذابًا يعكس هوية علامتك التجارية.",
                    },
                    management: {
                        title: "إدارة الحسابات",
                        desc: "نحافظ على حساباتك نشطة ومنظمة عبر جدول نشر ومتابعة الرسائل وإدارة المجتمع.",
                    },
                    reels: {
                        title: "ريلز والفيديو القصير",
                        desc: "نروي قصة علامتك بشكل جذاب وعالي التفاعل من خلال مقاطع الفيديو القصيرة.",
                    },
                    analytics: {
                        title: "التخطيط والتحليل",
                        desc: "نحلل بيانات الأداء لتطوير استراتيجيتك باستمرار والتركيز على النتائج.",
                    },
                },
            },
            services: {
                title: "خدماتنا",
                subtitle: "نقدم حلولاً مخصصة لعلامتك التجارية مع فريقنا الاحترافي.",
                items: {
                    video: {
                        title: "إنتاج الفيديو",
                        desc: "تصوير وإنتاج فيديو احترافي للعروض المؤسسية والإعلانات ووسائل التواصل الاجتماعي.",
                    },
                    photo: {
                        title: "التصوير الفوتوغرافي",
                        desc: "إنتاج مرئي عالي الجودة في تصوير المنتجات والفعاليات والبورتريه والمعمار.",
                    },
                    social: {
                        title: "إدارة وسائل التواصل",
                        desc: "استراتيجية المحتوى والإنتاج وإدارة الحسابات لتعزيز هوية علامتك الرقمية.",
                    },
                    drone: {
                        title: "تصوير بالطائرة المسيّرة",
                        desc: "تصوير جوي ومقاطع فيديو بزوايا علوية مبهرة. مثالي للإنشاءات والسياحة والفعاليات.",
                    },
                    edit: {
                        title: "مونتاج الفيديو وما بعده",
                        desc: "تصحيح الألوان وتصميم الصوت والمؤثرات الخاصة — لمسة احترافية نهائية لمقاطع الفيديو الخاصة بك.",
                    },
                    live: {
                        title: "خدمات الويب",
                        desc: "تصميم وتطوير وصيانة المواقع المؤسسية. حلول ويب حديثة ومتجاوبة.",
                    },
                },
            },
            webServices: {
                title: "خدمات الويب لدينا",
                subtitle: "المواقع التي قمنا بتطويرها وإدارتها",
                visitSite: "زيارة الموقع",
            },
            seo: {
                home: {
                    title: "Kochan Productions | إنتاج الفيديو ووسائل التواصل الاجتماعي | يالوفا، تركيا",
                    description: "إنتاج فيديو احترافي وتصوير فوتوغرافي وإدارة وسائل التواصل الاجتماعي من يالوفا، تركيا. فيديوهات مؤسسية وإعلانات ومقاطع تصوير جوي بالطائرات المسيّرة لعلامتك.",
                },
                work: {
                    title: "صورنا | Kochan Productions",
                    description: "شاهد أعمالنا الاحترافية في تصوير المنتجات والفعاليات والبورتريه والمعمار. معرض صور Kochan Productions.",
                },
                about: {
                    title: "عنا | Kochan Productions - موجاهيت كوتشان",
                    description: "تقدم Kochan Productions خدمات الفيديو والتصوير ووسائل التواصل الاجتماعي بخبرة سنوات. تعرف على مؤسسنا موجاهيت كوتشان.",
                },
                contact: {
                    title: "تواصل معنا | Kochan Productions - يالوفا، تركيا",
                    description: "تواصل مع Kochan Productions لخدمات إنتاج الفيديو والتصوير وإدارة وسائل التواصل الاجتماعي. يالوفا، تركيا.",
                },
                socialMedia: {
                    title: "إدارة وسائل التواصل الاجتماعي | Kochan Productions",
                    description: "خدمات إدارة وسائل التواصل الاجتماعي الاحترافية. عزز حضور علامتك التجارية عبر الإنترنت مع استراتيجية المحتوى والتسويق الرقمي.",
                },
                webServices: {
                    title: "خدمات الويب | Kochan Productions",
                    description: "نقدم لشركات يالوفا خدمات تصميم وتطوير وصيانة المواقع المؤسسية باحترافية. حلول ويب حديثة وسريعة ومتجاوبة ومتوافقة مع محركات البحث لتعزيز حضورك الرقمي.",
                },
                projects: {
                    titleSuffix: " | Kochan Productions",
                    descriptionPrefix: "Kochan Productions - ",
                    descriptionSuffix: " أعمال إنتاج الفيديو الاحترافية في فئة.",
                },
            },
            notFound: {
                title: "الصفحة غير موجودة | Kochan Productions",
                heading: "الصفحة غير موجودة",
                description: "ربما تم نقل الصفحة التي تبحث عنها أو أنها غير موجودة. يمكنك تصفح أعمالنا من الصفحة الرئيسية.",
                backHome: "العودة إلى الصفحة الرئيسية",
            },
        },
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "tr",
        supportedLngs: ["tr", "en", "ar"],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
        },
    });

export default i18n;


